import { generateAssetCdnUrl } from '@tickled-media/web-components.tm-helpers';
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import cx from '../../../styles';
//import ComposeContainer from '../../../containers/Compose';
import LoginContainer, { onLogout } from '../../../containers/Login';
import NotificationContainer from '../../../containers/Notification';
import { ProfileThumb } from '../../Common/CardComponents';
//import GetAppWidget from '../../AppDownload/GetAppWidget';
import { gtmSend, makeRoute } from '../../../helpers';
import { myIsSet, offset } from '@tickled-media/web-components.tm-helpers';
import appendResizeKey from '@tickled-media/components.tm-helper-append-resize-key-new';
import { Icon } from '../../Common/Icon';
import CONFIG from '../../../config';
// import NavigationHeader from '../../NavigationHeader';
import SearchBarContainer from '../../../containers/Search/SearchBar';
// import './style.css';

const subCategoryImageList = {
    0: generateAssetCdnUrl("tap-assets/SubCategory", "Allergies.png"),
    1: generateAssetCdnUrl("tap-assets/SubCategory", "Delivery.png"),
    2: generateAssetCdnUrl("tap-assets/SubCategory", "Pre_schooler.png"),
    3: generateAssetCdnUrl("tap-assets/SubCategory", "Pregnancy.png"),
    4: generateAssetCdnUrl("tap-assets/SubCategory", "Relationship.png"),
    5: generateAssetCdnUrl("tap-assets/SubCategory", "baby.png"),
    6: generateAssetCdnUrl("tap-assets/SubCategory", "meal_planner.png"),
    7: generateAssetCdnUrl("tap-assets/SubCategory", "news.png")
};

const ToolsNav = React.memo((props) => {
    const {t, appReducer, userReducer, articleLink} = props;
    return (
        <Fragment>
            <li>
                <ul className={cx("user-details-header")}>
                    <li>{t('community_title')}</li>
                </ul>
            </li>
            {/*<li>
                <ComposeContainer isMobile={true} buttonType="text" checkVisibility={false} match={match} />
            </li>*/}
            <li className={cx("poll-link")}>
                <span className={cx("icon-wrap")}>
                    <Icon name="sidebar-poll-icon-regular" />
                </span>
                <span>
                    <a 
                        href={makeRoute('/feed/poll', appReducer)}
                        onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'poll')}
                    >
                        {t('community_tab_poll')}
                    </a>
                </span>
            </li>
            <li className={cx("photo-link")}>
                <span className={cx("icon-wrap")}>
                    <Icon name="sidebar-photo-icon-regular" />
                </span>
                <span>
                    <a 
                        href={makeRoute('/booth', appReducer)}
                        onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'booth')}
                    >
                        {t('community_tab_booth')}
                    </a>
                </span>
            </li>
            <li className={cx("food-link")}>
                <span className={cx("icon-wrap")}>
                    <Icon name="food-icon" />
                </span>
                <span>
                    <a 
                        href={makeRoute('/food', appReducer)}
                        onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'food')}
                    >
                        {t('food')}
                    </a>
                </span>
            </li>
            <li className={cx("recipes-link")}>
                <span className={cx("icon-wrap")}>
                    <Icon name="recipes-icon" />
                </span>
                <span>
                    <a 
                        href={makeRoute('/recipes', appReducer)}
                        onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'recipes')}
                    >{t('recipes')}</a>
                </span>
            </li>
            <li className={cx("topics-link")}>
                <span className={cx("icon-wrap")}>
                    <Icon name="sidebar-topics-icon-regular" />
                </span>
                <span>
                    <a 
                        href={makeRoute('/topics', appReducer)}
                        onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'topics')}
                    >
                        {t('community_tab_topic')}
                    </a>
                </span>
            </li>
            <li className={cx("articles-link")}>
                <span className={cx("icon-wrap")}>
                    <Icon name="sidebar-articles-icon-regular" />
                </span>
                <span>
                    <a 
                        href={articleLink}
                        onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'articles')}
                    >
                        {t('community_tab_read_articles')}
                    </a>
                </span>
            </li>
            {
                userReducer.id &&
                <li className={cx("manage-kids-link")}>
                    <span className={cx("icon-wrap")}>
                        <Icon name="sidebar-manage-kids-icon-regular" />
                    </span>
                    <span>
                        <a 
                            href={makeRoute('/app/download', appReducer)}
                            onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'manage kids')}
                        >
                            {t('community_tab_manage-kids')}
                        </a>
                    </span>
                </li>
            }
            <li className="divider"></li>
            <li>
                <ul className={cx("user-details-header")}>
                    <li>{t('home_tracker_title')}</li>
                </ul>
            </li>
            <li className={cx("pregnancy-tracker-link")}>
                <span className={cx("icon-wrap")}>
                    <Icon name="sidebar-pregnancy-tracker-icon-regular" />
                </span>
                <span>
                    <a 
                        href={makeRoute('/tracker/pregnancy', appReducer)}
                        onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'pregnancy tracker')}
                    >
                        {t('community_tab_pregnancy_tracker')}
                    </a>
                </span>
            </li>
            <li className={cx("baby-tracker-link")}>
                <span className={cx("icon-wrap")}>
                    <Icon name="sidebar-baby-tracker-icon-regular" />
                </span>
                <span>
                    <a 
                        href={makeRoute('/tracker/baby', appReducer)}
                        onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'baby tracker')}
                    >
                        {t('community_tab_baby_tracker')}
                    </a>
                </span>
            </li>
            <li className="divider"></li>
            <li>
                <ul className={cx("user-details-header")}>
                    <li>{t('menu_rewards')}</li>
                </ul>
            </li>
            <li className={cx("rewards-link")}>
                <span className={cx("icon-wrap")}>
                    <img src={`https://parenttown-prod.s3-ap-southeast-1.amazonaws.com/assets/tools/Reward.png`} alt={t('menu_rewards')} width="30" height="30" loading="lazy" />
                </span>
                <span>
                    <a 
                        href={makeRoute('/rewards', appReducer)}
                        onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'rewards')}
                    >
                        {t('menu_rewards')}
                    </a>
                </span>
            </li>
            <li className={cx("contests-link")}>
                <span className={cx("icon-wrap")}>
                    <Icon name="sidebar-contests-icon-regular" />
                </span>
                <span>
                    <a 
                        href={makeRoute('/contests', appReducer)}
                        onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'contests')}
                    >
                        {t('contest_title')}
                    </a>
                </span>
            </li>
            <li className={cx("vip-link")}>
                <span className={cx("icon-wrap")}>
                   <img src={subCategoryImageList[Math.floor(Math.random()*(Object.keys(subCategoryImageList).length))]} alt={t('tools_vip')} width="30" height="30" loading="lazy" />
                </span>
                <span>
                    <a 
                        href={'https://www.parents.vip/'}
                        onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'vip')}
                    >
                        {t('tools_vip')}
                    </a>
                </span>
            </li>

            {
                userReducer.id && false &&
                <li>
                    <ul className={cx("user-details-header")}>
                        <li>Tell your friends</li>
                    </ul>
                </li>
            }

            {
                userReducer.id && false &&
                <li className={cx("invite-a-friend-link")}>
                    <span className={cx("icon-wrap")}>
                        <Icon name="sidebar-invite-a-friend-icon-regular" />
                    </span>
                    <span>
                        <a href={makeRoute('/contact', appReducer)}>{t('menu_invite_friend')}</a>
                    </span>
                </li>
            }
            <li className="divider"></li>
            <li>
                <ul className={cx("user-details-header")}>
                    <li>{t('menu_more')}</li>
                </ul>
            </li>

            <li className={cx("feedback-link")}>
                <span className={cx("icon-wrap")}>
                    <Icon name="sidebar-feedback-icon-regular" />
                </span>
                <span>
                    <a 
                        href={makeRoute('/contact', appReducer)}
                        onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'feedback')}
                    >
                        {t('menu_feedback')}
                    </a>
                </span>
            </li>
        </Fragment>
    )
})

const ArticlesNav = React.memo((props) => {
    const {t, headerMenu} = props;
    return (
        <Fragment>
            <li>
                <ul className={cx("user-details-header")}>
                    <li>{t('menu_articles')}</li>
                </ul>
            </li>
            {
                headerMenu && headerMenu.items && headerMenu.items.length > 0 &&
                headerMenu.items.map((item) => (
                    <li key={item.id}>
                        <span className={cx("icon-wrap")}>
                            <img src={item.image ? appendResizeKey(item.image, '150') : subCategoryImageList[Math.floor(Math.random()*(Object.keys(subCategoryImageList).length))]} alt={item.title} width="30" height="30" loading="lazy" />
                        </span>
                        <span>
                            <a 
                                href={item.url}
                                onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', item.title)}
                            >
                                {item.title}
                            </a>
                        </span>
                    </li>
                ))
            }
        </Fragment>
    )
})

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //isLeftSlideOpen: false,
            isMenuSlideUp: false,
            isSearchBoxOpen : false,
            showSearch: false,
            isLogoutLoading: false,
        };
    }

    
    componentDidMount() {
        if (typeof window != 'undefined') {
            this.previous = window.scrollY;
            window.addEventListener('scroll', this.headerStickyHandler);
        }
    }

    componentWillUnmount() {
        if (typeof window != 'undefined') {
            window.removeEventListener('scroll', this.headerStickyHandler);
        }
    }

    
    onMobileCrossClick = () => {
        let lastUrl;
        const pathname = this.props.history.location.pathname;
        if (typeof window != 'undefined') {
            lastUrl = window.location.href;
        }
        if (pathname.indexOf('/q/') > -1 || pathname.indexOf('/contest/') > -1 || pathname.indexOf('/tracker/') > -1) {
            this.props.history.goBack();
            //webkit instance fix
            setTimeout(() => {
                if (typeof window != 'undefined' && window.location.href == lastUrl) this.props.history.replace({ pathname:'/feed' });
            }, 500);
        } else {
            this.props.history.replace({ pathname:'/feed' });
        }
    }

    headerStickyHandler = () => {
        //let endHeaderContentSection = offset(document.getElementById('endHeaderContentSection'));
        const startMainContentSection = offset(document.getElementById('startMainContentSection'));
        if (startMainContentSection.viewPortTop <= 0 && window.scrollY > this.previous) {
            this.setState({ isMenuSlideUp: true });
        } else {
            this.setState({ isMenuSlideUp: false });
        }
        this.previous = window.scrollY;
    }

    /*handleLeftSlideOpen = () => {
        if(!this.state.isLeftSlideOpen){
            gtmSend('dynamic', 'Hamburger', 'open', '');
        }
        else{
            gtmSend('dynamic', 'Hamburger', 'close', '');
        }
        this.setState({ isLeftSlideOpen: !this.state.isLeftSlideOpen });
    }*/

    checkIfActive = (path) => {
        const currentLocation = this.props.match.url;
        if (path == '/' && currentLocation == '/') {
            return "active";
        } else {
            return path != '/' && currentLocation.indexOf(path) > -1 ? "active" : "";
        }
    }

    ChangeIsSearchBoxOpen = () => {
        this.setState({
            isSearchBoxOpen : !this.state.isSearchBoxOpen
        })
    }

    render() {
        const t = this.props.t;
        const country = ['th', 'id', 'my', 'vn', 'ph'].indexOf(this.props.appReducer.locale) !== -1 ? this.props.appReducer.locale : 'sg';
        const articleLink = this.props.appReducer.country === "in" ? "https://theindusparent.com" : `https://${country}.theasianparent.com`;
        let headerLogo = {
            url: CONFIG['region']['s3Prefix'] + CONFIG['region']['logoImage'],
            desktopDimension: [170, 44],
            mobileDimension: [130, 33],
        };
        if (this.props.logoConfig) {
           headerLogo = {
               ...headerLogo,
               ...this.props.logoConfig,
           };
        }
        
        return (
            <header>
                <div className={cx(`header-top`)}>
                    {
                        this.state.isSearchBoxOpen &&
                        <div className={cx("search-box-wrapper")}>
                            <div className={cx('search-box-container')}>
                                <SearchBarContainer
                                    match={this.props.match}
                                />
                            </div>

                            <div onClick={() => this.ChangeIsSearchBoxOpen()} className={cx('close-btn')}>
                                <Icon name="cross-regular-dark-smd" />
                            </div>
                        </div>
                    }

                    <div className='t-header'>
                    <div className={cx({"h-left": true, "full-width": this.state.showSearch})}>
                        {
                            this.props.showBackButton
                            ?
                                <a href="/feed" className={cx("only-mobile", "cross-wrap")} onClick={(e) => { e.preventDefault(); this.onMobileCrossClick(); }} aria-label="cross-button">
                                    <Icon name="cross-regular-dark-smd" />
                                </a>
                            :
                                <div className={cx("only-mobile", "hamburger-wrap")} onClick={() => this.props.handleLeftSlideOpen()}>
                                    <Icon name="hamburger-regular-dark-md" />
                                </div>
                        }
                        {
                            !this.state.showSearch && (
                            <div className={cx(`logo-wrap ${this.props.page === 'LoginPage' ? 'center-wrap' : ''}`)}>
                                <a href={makeRoute('/feed', this.props.appReducer)}
                                   aria-label="theAsianparent community logo - Go to feed page" onClick={() => {
                                    gtmSend('cw_logo_click', 'Logo', 'Logo Click', `${window.location}`, 0)
                                }}>
                                    <img
                                        className={cx('not-mobile', 'logo')}
                                        src={headerLogo.url}
                                        height={headerLogo.desktopDimension[1]}
                                        width={headerLogo.desktopDimension[0]}
                                        alt="theAsianparent-logo" loading="lazy"
                                    />
                                    <img
                                        className={cx('only-mobile', 'logo')}
                                        src={headerLogo.url}
                                        height={headerLogo.mobileDimension[1]}
                                        width={headerLogo.mobileDimension[0]}
                                        alt="theAsianparent-logo"
                                        loading="lazy"
                                    />
                                </a>
                            </div>
                            )
                        }
                        <div className={cx({'only-desktop': !this.state.showSearch})}>
                            <div className={cx('header-search-bar')}>
                                <SearchBarContainer match={this.props.match} />
                            </div>
                        </div>
                        {this.state.showSearch && <div className="close-search-btn flex" onClick={() => this.setState({showSearch: false})}>
                            <Icon name="cross-regular-dark-smd" className='' />
                        </div>}
                    </div>

                    {
                        !this.props.isMobile && !this.state.showSearch &&
                        <div className={cx("h-right")}>

                        {
                            this.props.match.url !== '/search' && this.props.page !== 'LoginPage' &&
                            <div
                                className={cx("not-desktop h-top-links")}
                                onClick={() => {
                                    gtmSend('click search button', 'search', 'click', 'mobile');
                                    this.setState({showSearch: true})
                                    // this.ChangeIsSearchBoxOpen()
                                }
                            }>
                                {/* <a href={makeRoute('/search', this.props.appReducer)} aria-label="search-icon"> */}
                                    <Icon name="search-regular-dark" />
                                {/* </a> */}
                            </div>
                        }

                        {
                            this.props.userReducer.id &&
                            <div className={cx("h-top-links l-border")}>
                                <NotificationContainer />
                            </div>
                        }

                            <div className={cx("h-top-links")}
                                onClick={() => {
                                window.location.href = `https://${country}.theasianparent.com/products`}}>
                                <Icon name='product-guide-regular' />
                                <div className={cx("only-desktop")}>{t('product_guide')}</div>
                            </div>
                            {
                                process.env.REACT_APP_SHOP_ACTIVE_IN.indexOf(this.props.appReducer.country) !== -1 &&
                                <div className={cx("h-top-links")}
                                onClick={() => window.location.href = `${process.env.REACT_APP_TAP_SHOP_SITEURL}/cart`}>
                                    <div className={cx("cart")}
                                    >
                                        <Icon name='cart-regular' />
                                        <div className={cx("only-desktop")}>{t('cart')}</div>
                                        {
                                            this.props.cartCount > 0 &&
                                            <div className={cx('cartCount')}>{this.props.cartCount}</div>
                                        }
                                    </div>
                                </div>
                            }

                        {
                            this.props.page !== 'LoginPage' &&
                            <div className={cx("only-desktop")}>
                                <LoginContainer mode={this.props.match.url == '/booth' || this.props.match.url == '/user/settings' ? "inlineBooth" : "inline"} history={this.props.history} match={this.props.match}/>
                            </div>
                        }
                    </div>
                    }
                    </div>
                    <nav className={cx("nav-links")}>
                        <ul>
                            <li>
                                <a
                                    href={makeRoute('/feed', this.props.appReducer)}
                                    className={cx(this.props.match.url === '/feed' ? this.checkIfActive('/feed') : '')}
                                    onClick={() => {gtmSend('dynamic', 'Top Navigation Desktop', 'click', 'home'); gtmSend('cw_navigation_bar', 'Navigation Bar', 'home', '--', 0); window.scrollTo(0,0);}}
                                >
                                    {t('menu_home')}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={makeRoute('/contests', this.props.appReducer)}
                                    className={cx(this.checkIfActive('/contest'))}
                                    onClick={() => {gtmSend('dynamic', 'Top Navigation Desktop', 'click', 'contest'); gtmSend('cw_navigation_bar', 'Navigation Bar', 'contest', '--', 0)}}
                                >
                                    {t('contest_title')}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={makeRoute('/recipes', this.props.appReducer)}
                                    className={cx(this.checkIfActive('/recipes'))}
                                    onClick={() =>{gtmSend('dynamic', 'Top Navigation Desktop', 'click', 'recipes'); gtmSend('cw_navigation_bar', 'Navigation Bar', 'recipies', '--', 0)}}
                                >
                                    {t('recipes')}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={makeRoute('/food', this.props.appReducer)}
                                    className={cx(this.checkIfActive('/food'))}
                                    onClick={() => {gtmSend('dynamic', 'Top Navigation Desktop', 'click', 'food'); gtmSend('cw_navigation_bar', 'Navigation Bar', 'food', '--', 0)}}
                                >
                                    {t('food')}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={makeRoute('/tracker', this.props.appReducer)}
                                    className={cx(this.checkIfActive('/tracker'))}
                                    onClick={() => {gtmSend('dynamic', 'Top Navigation Desktop', 'click', 'tracker'); gtmSend('cw_navigation_bar', 'Navigation Bar', 'tracker', '--', 0)}}
                                >
                                    {t('home_tracker_title')}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={makeRoute('/topics', this.props.appReducer)}
                                    className={cx(this.checkIfActive(myIsSet(this.props.match.params,'slug') ? '/topic/' + this.props.match.params.slug : '/topics'))}
                                    onClick={() => {gtmSend('dynamic', 'Top Navigation Desktop', 'click', 'topics'); gtmSend('cw_navigation_bar', 'Navigation Bar', 'topics', '--', 0)}}
                                >
                                    {t('community_tab_topic')}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={articleLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => {gtmSend('dynamic', 'Top Navigation Desktop', 'click', 'articles'); gtmSend('cw_navigation_bar', 'Navigation Bar', 'articles', '--', 0)}}
                                >
                                    {t('articles')}
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>

                <div className={(this.props.isLeftSlideOpen ? "leftSlideOverlay" : "")}></div>

                <div className={cx("only-mobile", "left-slide-panel", (this.props.isLeftSlideOpen ? "active" : ""))}>
                    <span className={cx(`close ${this.props.page === 'LoginPage'? 'grey' : ''}`)} onClick={() => this.props.handleLeftSlideOpen()} >
                        <Icon name="cross-regular-dark-smd" />
                    </span>

                    {
                        this.props.page !== 'LoginPage' &&
                        <Fragment>
                            {
                                this.props.userReducer.id
                                ?
                                    <div className={cx("user-details")}>
                                        <ProfileThumb img={this.props.userReducer.image ? this.props.userReducer.image : ""} size="large" altName={`${this.props.userReducer.full_name} profile icon`} />

                                        <div className={cx("author-name")}>
                                            <div>{this.props.userReducer.full_name}</div>
                                            <p>
                                                <a
                                                    href="/logout"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (this.state.isLogoutLoading) {
                                                            return;
                                                        }
                                                        this.setState({ isLogoutLoading: true });
                                                        onLogout('mobile', this.props.appReducer, this.props.userReducer);
                                                    }}
                                                >
                                                    { this.state.isLogoutLoading  ? `${t('loading')}...` : t('menu_logout')}
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                :
                                    <div className={cx("user-details")}>
                                        <div className={cx("offline-profile-thumb")}></div>

                                        <div className={cx("login-signup-style")}>
                                            <a href="/login" onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'login')}>{t('sidebar_login')} / {t('sidebar_signup')}</a>
                                        </div>
                                    </div>
                            }
                        </Fragment>
                    }

                    <div className={cx(`sidebar-menu-wrap ${this.props.page === 'LoginPage'? 'top-wrap' : ''}`)}>
                        <ul>
                            {
                                this.props.userReducer.id &&
                                <li className={cx("profile-link")}>
                                    <span className={cx("icon-wrap")}>
                                        <Icon name="sidebar-profile-icon-regular" />
                                    </span>
                                    <span>
                                        <Link
                                            to={`/user/${this.props.userReducer.slug}`}
                                            rel="nofollow"
                                            onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'profile')}
                                        >
                                            {t('menu_profile')}
                                        </Link>
                                    </span>
                                </li>
                            }

                            {
                                this.props.userReducer.id &&
                                <li className={cx("setting-link")}>
                                    <span className={cx("icon-wrap")}>
                                        <Icon name="sidebar-settings-icon-regular" />
                                    </span>
                                    <span>
                                        <Link
                                            to={`/user/settings`}
                                            rel="nofollow"
                                        >
                                            {t('menu_settings')}
                                        </Link>
                                    </span>
                                </li>
                            }

                            {
                                this.props.drawerSource === 'tools'
                                ?
                                <Fragment>
                                    <ToolsNav
                                        t={t}
                                        match={this.props.match}
                                        appReducer={this.props.appReducer}
                                        articleLink={articleLink}
                                        userReducer={this.props.userReducer} />

                                    <li className="divider"></li>

                                    <ArticlesNav
                                        t={t}
                                        headerMenu={this.props.appReducer.headerMenu} />
                                </Fragment>
                            :
                                <Fragment>
                                    <ArticlesNav
                                        t={t}
                                        headerMenu={this.props.appReducer.headerMenu} />

                                    <li className="divider"></li>

                                    <ToolsNav
                                        t={t}
                                        match={this.props.match}
                                        appReducer={this.props.appReducer}
                                        articleLink={articleLink}
                                        userReducer={this.props.userReducer} />
                                </Fragment>
                            }
                        </ul>

                        <div className={cx("download-app-section")}>
                            <p>
                                <Link
                                    to={makeRoute('/privacy', this.props.appReducer)}
                                    onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'privacy policy')}
                                >
                                    {t('menu_privacy_policy')}
                                </Link>
                                <Link
                                    to={makeRoute('/community-guideline', this.props.appReducer)}
                                    onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'community guidelines')}
                                >
                                    {t('community_guidelines')}
                                </Link>
                                <a
                                    href={makeRoute('/sitemap', this.props.appReducer)}
                                    onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'sitemap html')}
                                >
                                    {t('menu_sitemap_html')}
                                </a>
                            </p>
                            <p>
                                <span>
                                    {t('download_our_free_app')}
                                </span>
                            </p>
                            <div className={cx("clear-fix")}></div>
                            {

                                CONFIG['region'].region == 'asia' &&
                                <div className={cx("social-app-wrap")}>
                                    <div className={cx("google-play-btn")}>
                                        <a href={makeRoute("https://community.theasianparent.com/app/download?mt=8", this.props.appReducer)} onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'google play store')} aria-label="Download theAsianparent app from google play store">
                                            <img src={generateAssetCdnUrl("html-edm/2018/sep/tap-welcome", "icon-android.svg")} alt="google play store" loading="lazy" width="125" height="36" />
                                        </a>
                                    </div>
                                    <div className={cx("play-store-btn")}>
                                        <a href={makeRoute("https://community.theasianparent.com/app/download", this.props.appReducer)} onClick={() => gtmSend('dynamic', 'Sidebar menu', 'click', 'app store')} aria-label="Download theAsianparent app from app store">
                                            <img src={generateAssetCdnUrl("html-edm/2018/sep/tap-welcome", "icon-ios.svg")} alt="app store" loading="lazy" width="125" height="36" />
                                        </a>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </header>
        );
    }

}

export default translate()(Header);
